module.exports = __webpack_public_path__ + "img/svg.510b2fad.svg";